import { type FC } from 'react'

import { NavigationText, TagText } from '@/components/core'

import { getOrganizationInitials } from './utils'

interface WorkspaceDropdownItemBodyProps {
  name: string
  avatarTestId?: string
  nameTestId?: string
}

/** A workspace in either portal's workspace dropdown: its initials, then its name. */
export const WorkspaceDropdownItemBody: FC<WorkspaceDropdownItemBodyProps> = ({ name, avatarTestId, nameTestId }) => (
  <>
    <div className="sidebar__org-avatar" data-testid={avatarTestId}>
      <TagText>{getOrganizationInitials(name)}</TagText>
    </div>
    <NavigationText className="sidebar__org-dropdown-item-name" data-testid={nameTestId}>
      {name}
    </NavigationText>
  </>
)
